// React thing
import { useEffect, useRef, useState } from 'react';

// Styles
import style from './AchivementSection.module.css'

// Stores
import useSourceStore from '../../Store/SourceStore.js'


export default function AchivementSection(props){

    const achivement = useSourceStore((state)=> state.achivement)

    function setup(){
    }

    useEffect(()=>{
        setup()
    }, [])

    return(
        <img 
        onLoad={()=>{

        }}

        className={style['section-container']} src={'/achivement.webp'}></img>
    )
}